import React from 'react';

const HeroSection = () => {
  const scrollToCalculator = () => {
    document.getElementById('calculator').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="min-h-screen flex items-center justify-center px-4 py-20">
      <div className="max-w-5xl mx-auto text-center fade-in">

        <h1 className="text-7xl font-bold mb-6 gradient-text">
          ORBTX
        </h1>

         {/* Main Headline */}
        <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-6">
          Plan Physics-Accurate Orbital Transfers in Seconds
        </h1>

        {/* Infrastructure Positioning */}
        <p className="text-lg md:text-xl text-cyan-400 font-medium mb-4">
          The computational infrastructure layer for orbital mechanics
        </p>

        {/* Vision Statement */}
        <div className="text-base md:text-lg text-gray-300 mb-8 space-y-1">
          <p>Physics-based transfer modeling today</p>
          <p>AI-driven mission intelligence tomorrow</p>
        </div>


        <p className="text-sm text-gray-500 mb-10">
          No sign-up required • Physics-accurate • Instant results
        </p>

        <div className="flex justify-center gap-4 flex-wrap">
          <button
            onClick={scrollToCalculator}
            className="bg-primary-600 hover:bg-primary-700 text-white px-8 py-4 rounded-lg text-lg font-semibold shadow-lg hover:shadow-xl transition-all"
          >
            Try ORBTX Free →
          </button>

          <a
            href="/api/docs"
            target="_blank"
            rel="noopener noreferrer"
            className="border border-gray-600 hover:border-primary-500 text-gray-300 hover:text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all"
          >
            Explore API
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;